<template>
    <div id="customFieldModal" class="modal" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-lg">{{ form.name ? form.name : 'New Custom Field' }}</h4>
                    <button type="button"
                            class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                            data-dismiss="modal" @click="closeModal()">close
                    </button>
                </div>
                <div class="modal-body">
                    <form @keydown="form.errors.clear($event.target.name)">
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="name"
                                    :class="{'text-red': form.errors.has('name')}">Name</label>
                            <input v-model="form.name" id="name" name="name"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('name')}" v-if="openModalFor == 'new'">
                            <span class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full d-flex cursor-not-allowed" style="opacity:0.7" v-else>{{form.name}}</span>
                            <div class="text-red text-xs" v-if="form.errors.has('name')">
                                {{ form.errors.get('name') }}
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="type"
                                    :class="{'text-red': form.errors.has('type')}">Type</label>
                            <div>
                                <select name="" id=""
                                    class="bg-white border-1 focus:outline-none px-2 text-grey-darkest text-sm"
                                    v-model="form.type">
                                    <option default></option>
                                    <option value="1">User</option>
                                    <option value="2">Text</option>
                                    <option value="3">DropDown</option>
                                    <option value="4">Date</option>
                                </select>
                                <div class="text-red text-xs" v-if="form.errors.has('type')">{{
                                    form.errors.get('type') }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="label_value"
                                    :class="{'text-red': form.errors.has('name')}">Display label</label>
                            <input v-model="form.label_value" id="label_value" name="label_value"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('label_value')}">
                            <div class="text-red text-xs" v-if="form.errors.has('label_value')">
                                {{ form.errors.get('label_value') }}
                            </div>
                        </div>
                        <div>
                            <label class="text-sm text-grey-darkest mb-0" for="load_order"
                                    :class="{'text-red': form.errors.has('name')}">Load Order</label>
                            <div>
                                <input v-model="form.load_order" id="load_order" name="load_order" type="number"
                                    class="appearance-none bg-white border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-1/2"
                                    :class="{'border-red': form.errors.has('load_order')}">
                                <div class="text-red text-xs" v-if="form.errors.has('load_order')">
                                    {{ form.errors.get('load_order') }}
                                </div>
                            </div>
                        </div>
                        <div class="flex py-1">
                            <input v-model="form.enabled" id="enabled" name="enabled" type="checkbox"
                                   class="bg-white border-1"
                                   :class="{'border-red': form.errors.has('enabled')}">
                            <label class="text-sm text-grey-darkest px-1 mb-0" for="enabled"
                                    :class="{'text-red': form.errors.has('enabled')}">Enabled</label>
                        </div>
                        <div class="text-red text-xs" v-if="form.errors.has('enabled')">
                            {{ form.errors.get('enabled') }}
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button @click.prevent="saved"
                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                        Save
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";

    export default {
        name: 'change-order-custom-field-modal',
        props: ['team', 'customFields'],
        data() {

            return {
                form: new Form({
                    id: '',
                    name: '',
                    type: '',
                    label_value: '',
                    load_order: '',
                    enabled: false,
                    label_view: false,
                }),
                openModalFor:'new',
            }
        },
        created() {
        },
        methods: {
            open(custom_field = null) {
                $(this.$el).modal('show');
                if (custom_field) {
                    this.form.id = custom_field.id;
                    this.form.name = custom_field.name;
                    this.form.type = custom_field.type;
                    this.form.label_value = custom_field.label_value;
                    this.form.load_order = custom_field.load_order;
                    this.form.enabled = custom_field.enabled;
                    this.openModalFor = 'edit';
                } else {
                    this.form.reset();
                    this.form.enabled = false;
                    this.form.label_view = false;
                    this.openModalFor = 'new';
                }
            },

            saved() {
                let self = this;
                self.form.label_view = self.form.enabled;
                if (this.form.id) {
                    this.form.put(route('api.change-order-custom-field.update',  this.form.id)).then((data) => {
                        $("#customFieldModal").modal("hide");
                        self.$emit('saved', data.field.id);
                        self.closeModal();
                    });
                } else {
                    this.form.post(route('api.change-order-custom-field.store')).then((data) => {
                        $("#customFieldModal").modal("hide");
                        self.$emit('saved', data.field.id);
                        self.closeModal();
                    });
                }
            },
            closeModal() {
                let self = this;
                self.form.errors.errors = {};
            },
        }
    }
</script>
